import { RootState } from '../../store';

const selectMiembroState = (state: RootState) => state.registerMiembro;

export const selectFormData = (state: RootState) =>
  selectMiembroState(state).form_data;

export const selectMiembroLoading = (state: RootState) =>
  selectMiembroState(state).loading_register;

export const selectMiembroMiembro = (state: RootState) =>
  state.registerMiembro.miembro;

export const selectMiembroErrors = (state: RootState) =>
  selectMiembroState(state).errors;

export const selectMiembroSocio = (state: RootState) =>
  selectMiembroState(state).socio;

export const selectMiembroIsSocio = (state: RootState) =>
  selectMiembroSocio(state).es_socio;

export const selectSelectedPrice = (state: RootState) =>
  state.registerMiembro.socio.datos_socio
    ? state.registerMiembro.socio.datos_socio.price
    : null;

export const selectMiembroIsSocioCooperativa = (state: RootState) =>
  selectMiembroSocio(state).datos_socio?.socio_tipo === 'cooperativa';

export const selectMiembroIsSocioOrganizacion = (state: RootState) =>
  selectMiembroSocio(state).datos_socio?.socio_tipo === 'organizacion';

export const selectMiembroSetupIntent = (state: RootState) =>
  selectMiembroSocio(state).setup_intent;

export const selectMiembroPaymentMethod = (state: RootState) =>
  selectMiembroSocio(state).payment_method;

export const selectMiembroSocioLoading = (state: RootState) =>
  selectMiembroSocio(state).loading_setup_intent;

export const selectMiembroSocioErrors = (state: RootState) =>
  selectMiembroSocio(state).errors;

export const selectMustValidatePaymentMethod = (state: RootState) => {
  if (!selectMiembroIsSocio(state)) {
    return false;
  }
  return selectMiembroSetupIntent(state)?.status !== 'succeeded';
};

export const selectMiembroRegisterCompleted = (state: RootState) => {
  return selectMiembroState(state).registro_completado;
};

export const selectMiembroIsVoluntario = (state: RootState) =>
  selectMiembroState(state).voluntario;

export const selectMiembroIsPersonaCuidadora = (state: RootState) =>
  selectMiembroState(state).persona_cuidadora;

export const selectRegisterStep = (state: RootState) =>
  selectMiembroState(state).step;

/**                         Restricciones baja                       */
export const selectBajaRestrictions = (state: RootState) =>
  state.bajaRestrictions.data;

export const selectBajaRestrictionsLoading = (state: RootState) =>
  state.bajaRestrictions.loading;

/**                         Baja                                    */
export const selectBajaLoading = (state: RootState) => state.baja.loading;
